import { cn } from '@/v2/utils';

interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
}

export function Toggle({ checked, onChange, label }: ToggleProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      onClick={() => onChange(!checked)}
      className={cn(
        // inline-flex + items-center centers the knob vertically; p-[3px] gives an
        // even 3px inset on every side. Keep a border in BOTH states (transparent
        // when on) so the box model is identical and the knob travel is exact.
        'relative inline-flex items-center w-10 h-[22px] rounded-full p-[3px] transition-colors duration-200 shrink-0 border',
        checked ? 'bg-primary border-transparent' : 'bg-surface-light border-glass-border'
      )}
    >
      <span
        className={cn(
          // Travel = content(38) − 2×padding(6) − knob(16) = 16px, so the knob
          // stays fully inside the rounded track at both ends (no overflow).
          'block w-4 h-4 rounded-full bg-white shadow-sm transition-transform duration-200',
          checked ? 'translate-x-[16px]' : 'translate-x-0'
        )}
      />
    </button>
  );
}
